import { FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { StylelessButton } from "../../../ui-components/StylelessButton";
import { StyledButtonText } from "../../../ui-components/Typography";

import { EditCampaignAccessModal } from "./EditCampaignAccessModal";
import { setInitialUpdateUsersAccess, CampaignAccessDataUser } from "../store";
import { useAppSelector } from "../../../utils/hooks";
import { State } from "../../../utils/store";

interface UpdateCampaignAccessButtonProps {
  campaignUUID: string;
  campaignName: string;
  users: CampaignAccessDataUser[];
  buttonComponent?: any | null;
}

export const UpdatecampaignAccessButton: FC<UpdateCampaignAccessButtonProps> =
  ({ campaignUUID, campaignName, users, buttonComponent }) => {
    const dispatch = useDispatch();
    const ButtonComponent = buttonComponent || StylelessButton;
    const [modalVisible, setModalVisible] = useState(false);
    const { success } = useAppSelector(
      (state: State) => state.campaignAccessManagement.updateUsersAccess
    );

    useEffect(() => {
      if (success) {
        setModalVisible(false);
        dispatch(setInitialUpdateUsersAccess());
      }
    }, [success]);

    return (
      <>
        <EditCampaignAccessModal
          visible={modalVisible}
          handleModalClose={() => setModalVisible(false)}
          campaignUUID={campaignUUID}
          campaignName={campaignName}
          users={users}
        />
        <ButtonComponent onClick={() => setModalVisible(true)}>
          <StyledButtonText>Edit access</StyledButtonText>
        </ButtonComponent>
      </>
    );
  };
